const Controller = () => {
  const populateSnapshots = (snapshots) => {
    const docs = [];
    snapshots.forEach((snap) => {
      docs.push(extractSnapshotData(snap));
    });
    return docs;
  };

  const extractSnapshotData = (snap) => {
    return {
      id: snap.id,
      ...snap.data()
    };
  };

  return {
    async getAdsetsByCampaignId(campaignId) {
      return await this.collection("adsets")
        .where("campaignId", "==", campaignId)
        .get()
        .then(populateSnapshots);
    },

    async getAdsetById(id) {
      return await this.collection("adsets").doc(id).get().then(extractSnapshotData);
    },

    async updateAdsetById(id, data) {
      return await this.collection("adsets").doc(id).set(data, { merge: true });
    },

    async saveAdset(data) {
      return await this.collection("adsets").add(data);
    },

    async getAllAdsets() {
      return await this.collection("adsets").get().then(populateSnapshots);
    }
  };
};

module.exports = Controller;
